import { withChartLayout } from 'components/common';
import DevelopmentalScreen from 'components/features/chart/admission-history/developmental-screen/DevelopmentalScreen';

const DevelopmentalScreenPage = withChartLayout('Developmental Screen')(DevelopmentalScreen);
export default DevelopmentalScreenPage;
